export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
  vapidKey: string;
}

export const FIREBASE_CONFIG: FirebaseConfig = {
  apiKey: "AIzaSyCWzUOw7hbuU1qFHvv-82b5LIK0d3fv1u0",
  authDomain: "openbrix-dev.firebaseapp.com",
  projectId: "openbrix-dev",
  storageBucket: "openbrix-dev.firebasestorage.app",
  messagingSenderId: "1038323725141",
  appId: "1:1038323725141:web:00cbc674ac200ba56cb5dc",
  measurementId: "G-Q450EVZ47E",
  vapidKey: "BO19YB-W-8QR2CfMzI8RYeVDiDQznVcbgcaCZJvv3Dh4qVoXFR3SI9O4GBaZc4epUd48XSVjEXi7hbK2fMFdUeI",
};

export const VAPID_KEY = FIREBASE_CONFIG.vapidKey;
export const vapidKey = FIREBASE_CONFIG.vapidKey;

export const firebaseConfig = {
  apiKey: FIREBASE_CONFIG.apiKey,
  authDomain: FIREBASE_CONFIG.authDomain,
  projectId: FIREBASE_CONFIG.projectId,
  storageBucket: FIREBASE_CONFIG.storageBucket,
  messagingSenderId: FIREBASE_CONFIG.messagingSenderId,
  appId: FIREBASE_CONFIG.appId,
  measurementId: FIREBASE_CONFIG.measurementId,
};

export default FIREBASE_CONFIG;
